import { useSelector } from 'react-redux'
import { exclude, stringify } from 'query-string'
import { useEffect, useState } from 'react'

import { selectors } from '../redux'

function preventRedundantKeycloakQueryParams(url: string) {
  return exclude(url, ['session_state', 'code'])
}

export function useSsoUrl(context?: string, isRegister = false) {
  const settings = useSelector(selectors.settings.list)
  const userLoggedIn = !!useSelector(selectors.user.keycloakToken)
  const [ssoLoginUrl, setSsoLoginUrl] = useState('')

  useEffect(() => {
    if (userLoggedIn) {
      setSsoLoginUrl(
        settings?.sso_account_url || process.env.MANGER_BOUGER_ROOT || '/'
      )
      return
    }
    const url = !isRegister
      ? settings?.sso_login_url
      : settings?.sso_login_url?.replace('/auth?', '/registrations?')
    setSsoLoginUrl(
      `${url || '!#'}&${stringify({
        redirect_uri: preventRedundantKeycloakQueryParams(location.href) + '/',
        ...(context && {
          context,
        }),
      })}`
    )
  }, [
    settings?.sso_account_url,
    settings?.sso_login_url,
    context,
    userLoggedIn,
    isRegister,
  ])

  return ssoLoginUrl
}
